import React from 'react';
import { Trans } from 'react-i18next';

import careCreditIcon
  from '../../../assets/myAccount/reimbursement/card-credit.svg';

import './CareCreditMethodCard.css';

export const CareCreditMethodCard = ({
  addressCheck,
  careCreditAccount,
  isCheck,
  lastNumbers,
}) => {
  const secondaryBackup = isCheck
    ? 'reimbursementSection.careCreditOption.secondaryCheck'
    : 'reimbursementSection.careCreditOption.secondaryBank';

  return (
    <div className="CardCreditDetailsContainer">
      <img alt="" src={careCreditIcon} />

      <div>
        <p>
          <Trans
            components={{
              bold: <strong />,
            }}
            i18nKey="reimbursementSection.careCreditOption.primary"
            ns="myAccount"
            values={{
              ending: careCreditAccount,
            }}
          />
        </p>

        <span>
          <Trans
            components={{
              bold: <strong />,
            }}
            i18nKey={secondaryBackup}
            ns="myAccount"
            values={{
              ending: isCheck ? addressCheck : lastNumbers,
            }}
          />
        </span>
      </div>
    </div>
  );
};
